var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import uuid from 'uuid/v4';

var handleResponse = function handleResponse(response, endpointUrl) {
    if (response.ok) {
        if (201 === response.status) {
            return response.headers.get('Location') || endpointUrl;
        } else if (204 === response.status) {
            return true;
        } else {
            return response.json();
        }
    } else {
        return Promise.reject(response.status);
    }
};

var fetchResponse = function fetchResponse(endpointUrl, configuration, maxTries) {
    return fetch(endpointUrl, configuration).then(function (response) {
        if (503 === response.status || 504 === response.status) {
            return Promise.reject('retry');
        } else {
            return handleResponse(response, endpointUrl);
        }
    }).catch(function (error) {
        if ('retry' === error && 0 !== maxTries) {
            return fetchResponse(endpointUrl, configuration, maxTries - 1);
        } else {
            return Promise.reject(error);
        }
    });
};

var kitFetchFactory = function kitFetchFactory() {
    var useApiGateway = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return function (url) {
        var configuration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        var token = localStorage.getItem('kit.access_token');

        var headers = new Headers({
            'Authorization': 'Bearer ' + token,
            'Content-Type': 'application/json',
            'Correlation-Id': uuid()
        });

        var newConfiguration = _extends({}, configuration, {
            headers: headers
        });

        var endpointUrl = useApiGateway ? '' + process.env.REACT_APP_API_GATEWAY + url : url;

        return fetchResponse(endpointUrl, newConfiguration, 3);
    };
};

/**
 * Attaches Authorization header and fetches an api outside the apigateway.
 * @type {function(*, *=): Promise<Response>}
 */
export var kitFetchExternal = kitFetchFactory();

/**
 * Attaches Authorization header and fetches api through api gateway.
 * Api gateway must be defined in process.env.REACT_APP_API_GATEWAY.
 * Example: kitFetch('/museum-api/museums')
 * @type {function(*, *=): Promise<Response>}
 */
var kitFetch = kitFetchFactory(true);
export default kitFetch;